/**
 * Die Statusauswahl im Sheet `task-sheet` (`task-status`, Spec 06a, „Beim
 * Ändern zusätzlich ganz oben: Status"). Nur beim Ändern sichtbar — eine
 * neue Aufgabe ist immer `open` (Spec: „Rumpf POST /api/v1/tickets").
 *
 * Die Optionen kommen von `GET /tickets/statuses`, wie `TermReasonField` von
 * `GET /contracts/term-reasons`: der Client pflegt keine eigene Zuordnung von
 * Werten auf deutsche Bezeichnungen (`ARCHITECTURE.md` 5, AK-394).
 */

import { useTicketStatuses } from '@/features/tasks/api'
import { EnumSelectField } from '@/components/EnumSelectField'
import type { FieldError } from '@/components/FormField'

interface TaskStatusFieldProps {
  readonly testId: string
  readonly errorPrefix: string
  readonly value: string
  readonly onChange: (value: string) => void
  readonly error: FieldError | undefined
}

export function TaskStatusField({ testId, errorPrefix, value, onChange, error }: TaskStatusFieldProps) {
  const statusesQuery = useTicketStatuses()

  return (
    <EnumSelectField
      label="Status"
      testId={testId}
      apiField="status"
      errorPrefix={errorPrefix}
      options={statusesQuery.data ?? []}
      isPending={statusesQuery.isPending}
      value={value}
      onChange={onChange}
      error={error}
      required
    />
  )
}
